import { DialogueLine } from './store'

// Each story beat is a named sequence of dialogue lines that fire once.

export const storyBeats: Record<string, DialogueLine[]> = {
  cold_open: [
    {
      speaker: 'narrator',
      text: 'Tuesday. 3:47 AM. Boulder, Colorado.',
      duration: 3000,
    },
    {
      speaker: 'narrator',
      text: 'You wake up because the building is screaming.',
      duration: 3500,
    },
    {
      speaker: 'narrator',
      text: "Your ex-girlfriend's cat, Princess Donut, is perched on your chest. Judging you.",
      duration: 4500,
    },
    { speaker: 'carl', text: '...the hell?', duration: 2500 },
    {
      speaker: 'narrator',
      text: 'The ceiling cracks. The floor splits. The world — the actual world — is folding in on itself.',
      duration: 5000,
    },
    {
      speaker: 'narrator',
      text: 'You grab the cat. You run. There is no up anymore.',
      duration: 4000,
    },
    { speaker: 'narrator', text: 'You fall for a long time.', duration: 3500 },
    { speaker: 'system', text: 'WELCOME, CRAWLER.', duration: 3000 },
    {
      speaker: 'system',
      text: 'Scanning subject. Designation: CARL. Age: 29. Clothing inventory: one (1) pair of boxer shorts. Footwear: NEGATIVE.',
      duration: 5500,
    },
    {
      speaker: 'system',
      text: 'This has been flagged for special consideration. Sponsors will be notified.',
      duration: 4500,
    },
    {
      speaker: 'system',
      text: 'Your planet has been condemned. You have been selected for the Dungeon. Try to be entertaining.',
      duration: 5500,
    },
  ],

  first_breath_entry: [
    {
      speaker: 'system',
      text: 'ZONE: CHAMBER OF FIRST BREATH.',
      duration: 2800,
    },
    {
      speaker: 'mordecai',
      text: "Hey. Barefoot guy. Down here. Yeah, in your peripheral vision. Don't look directly at me, it freaks the viewers out.",
      duration: 5000,
    },
    {
      speaker: 'mordecai',
      text: "I'm Mordecai. I'm your AI-assigned coach. I've seen a thousand crawlers die on Floor 1 this week alone. Don't be one of them.",
      duration: 5500,
    },
    {
      speaker: 'mordecai',
      text: "The short version: move with WASD. Kick things with SPACE. Stomp with E. Your bare feet are actually an advantage — I don't want to know why.",
      duration: 6500,
    },
    {
      speaker: 'mordecai',
      text: "There's a portal on the far side. Walk into it. Try not to embarrass either of us.",
      duration: 4500,
    },
  ],

  tutorial_hollow_entry: [
    { speaker: 'system', text: 'ZONE: TUTORIAL HOLLOW.', duration: 2500 },
    {
      speaker: 'mordecai',
      text: "Goblins. Weakest things in the dungeon. If you can't kill these, uh. Well. Let's not dwell.",
      duration: 4500,
    },
    {
      speaker: 'mordecai',
      text: "Kick one into a wall. It'll die. It's violent and it's funny and the audience loves it. Go.",
      duration: 4500,
    },
  ],

  tutorial_hollow_cleared: [
    {
      speaker: 'system',
      text: 'HOSTILES NEUTRALIZED. CRAWLER HAS EXCEEDED MINIMUM SURVIVAL THRESHOLD. NOTED.',
      duration: 4500,
    },
    {
      speaker: 'mordecai',
      text: 'Okay. Not bad. Honestly I had money on you tripping. The next chamber has... something you should probably see.',
      duration: 5000,
    },
  ],

  donut_discovery_entry: [
    { speaker: 'system', text: "ZONE: DONUT'S DISCOVERY.", duration: 2500 },
    {
      speaker: 'system',
      text: 'UNIDENTIFIED BIOLOGICAL UNIT DETECTED. SCANNING...',
      duration: 3500,
    },
    {
      speaker: 'system',
      text: 'CLASSIFICATION: PRINCESS DONUT. SPECIES: DOMESTIC SHORTHAIR. LEVEL: 1. INTELLIGENCE: UNEXPECTEDLY HIGH.',
      duration: 5500,
    },
    {
      speaker: 'system',
      text: 'APPLYING SENTIENCE UPGRADE. THE AUDIENCE DEMANDS A TALKING CAT.',
      duration: 4500,
    },
    { speaker: 'donut', text: 'CARL.', duration: 2500 },
    {
      speaker: 'donut',
      text: 'Carl, I have THOUGHTS. I have OPINIONS. I have a VOCABULARY.',
      duration: 4500,
    },
    {
      speaker: 'donut',
      text: "Also you left the apartment on fire and your mother still hasn't called me back. We will address both.",
      duration: 5500,
    },
    { speaker: 'carl', text: 'Donut, the cat is talking.', duration: 3000 },
    {
      speaker: 'donut',
      text: "Princess Donut. Get it right, peasant. Now — there's a gnome ahead who sells things. I require treats.",
      duration: 5500,
    },
  ],

  merchant_nook_entry: [
    { speaker: 'system', text: "ZONE: MERCHANT'S NOOK.", duration: 2500 },
    {
      speaker: 'gnome',
      text: 'Oh my oh my, a fresh crawler! Barefoot, too — how bold, how inadvisable, how marketable!',
      duration: 5500,
    },
    {
      speaker: 'gnome',
      text: 'I am Mrs. Philomena Wartbottom-McGillicutty, licensed dungeon merchant, spiritual advisor, and occasional caterer.',
      duration: 5500,
    },
    {
      speaker: 'gnome',
      text: 'Step on up. Everything is reasonably priced. "Reasonable" being a flexible term in the Dungeon.',
      duration: 5000,
    },
    {
      speaker: 'mordecai',
      text: "She's overcharging you. Buy one potion, leave. Don't make eye contact with the cheese.",
      duration: 4500,
    },
  ],

  goblin_warrens_entry: [
    { speaker: 'system', text: 'ZONE: GOBLIN WARRENS.', duration: 2500 },
    {
      speaker: 'system',
      text: 'HOSTILE DENSITY: ELEVATED. SPONSOR INTEREST: RISING.',
      duration: 4000,
    },
    {
      speaker: 'mordecai',
      text: "This is a real fight. Not the tutorial. If you have potions, this is the place. Don't save them for later. There is no later.",
      duration: 6000,
    },
    {
      speaker: 'donut',
      text: "Carl, do not die. I refuse to be re-cloned into someone else's lap.",
      duration: 4500,
    },
  ],

  throne_entry: [
    { speaker: 'system', text: 'ZONE: THRONE OF BONES.', duration: 2800 },
    {
      speaker: 'system',
      text: 'BOSS ENCOUNTER INITIATED. THE GOBLIN KING HAS REQUESTED A CLOSED BROADCAST. THE REQUEST HAS BEEN DENIED.',
      duration: 6000,
    },
    {
      speaker: 'goblin_king',
      text: 'HUMAN. YOU ARE WEARING UNDERWEAR. I AM WEARING A CROWN. GUESS WHICH OF US RULES HERE.',
      duration: 5500,
    },
    {
      speaker: 'mordecai',
      text: "He's slow. He telegraphs everything. Kick the bone-piles around him into his face. Ratings will skyrocket. Go.",
      duration: 5500,
    },
  ],

  throne_cleared: [
    {
      speaker: 'goblin_king',
      text: 'impossible... a CRAWLER... without SHOES...',
      duration: 4000,
    },
    {
      speaker: 'system',
      text: 'GOBLIN KING DEFEATED. FLOOR 1 CLEARANCE CONFIRMED.',
      duration: 4500,
    },
    {
      speaker: 'system',
      text: 'ACHIEVEMENT UNLOCKED: YOU WILL NOT BREAK ME. AND YET: WE HAVE 17 MORE FLOORS TO TRY.',
      duration: 6000,
    },
    {
      speaker: 'mordecai',
      text: "You actually did it. I mean. Obviously I knew you would. That's what I'm paid to say.",
      duration: 5000,
    },
    {
      speaker: 'donut',
      text: 'Carl. Floor 2. Now. I have demands.',
      duration: 3500,
    },
  ],

  stairs_down: [
    { speaker: 'system', text: 'DESCENT TO FLOOR 2 IMMINENT.', duration: 3000 },
    {
      speaker: 'system',
      text: 'FLOOR 2 THEME: "SUBURBAN HORROR." CONTENT WARNINGS: EVERYTHING.',
      duration: 5000,
    },
    {
      speaker: 'mordecai',
      text: "Sleep if you can. You won't be able to. But try.",
      duration: 4000,
    },
  ],
}

// Randomly-selected ambient Mordecai lines that fire periodically
export const mordecaiAmbient: string[] = [
  'Your posture is terrible. The crowd notices these things.',
  "Hydrate. There's water in some of the crates. And some of the crates.",
  "The thing with three teeth you just killed? That was someone's cousin.",
  'Sponsors are up. Keep being weird.',
  "Don't look up. Trust me on this one.",
  'Your feet are bleeding. Narratively, this is a plus.',
  "I'm technically not allowed to help you directly. Consider this... suggestive narration.",
]

// Donut ambient when she\'s following you
export const donutAmbient: string[] = [
  'Carl, this floor smells like an airport bathroom.',
  'My previous owner kept a better pantry.',
  'If I die, I want to be buried in velvet. Non-negotiable.',
  "You're breathing loudly again.",
  "I've decided I'm a princess. Everyone agrees. Don't argue.",
]
